import React from 'react';
import axios from "axios"
import '../App.css';
import injectTapEventPlugin from 'react-tap-event-plugin';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

//Import React Scrit Libraray to load Google object
import Script from 'react-load-script';

require('../styles/TrialForm.css');
require('react-select/dist/react-select.css');
injectTapEventPlugin();

const state_list = [
  ['AL', '01'],
  ['AK', '02'],
  ['AZ', '04'],
  ['AR', '05'],
  ['CA', '06'],
  ['CO', '08'],
  ['CT', '09'],
  ['DC', '00'],
  ['DE', '10'],
  ['FL', '12'],
  ['GA', '13'],
  ['HI', '15'],
  ['ID', '16'],
  ['IL', '17'],
  ['IN', '18'],
  ['IA', '19'],
  ['KS', '20'],
  ['KY', '21'],
  ['LA', '22'],
  ['ME', '23'],
  ['MD', '24'],
  ['MA', '25'],
  ['MI', '26'],
  ['MN', '27'],
  ['MS', '28'],
  ['MO', '29'],
  ['MT', '30'],
  ['NE', '31'],
  ['NV', '32'],
  ['NH', '33'],
  ['NJ', '34'],
  ['NM', '35'],
  ['NY', '36'],
  ['NC', '37'],
  ['ND', '38'],
  ['OH', '39'],
  ['OK', '40'],
  ['OR', '41'],
  ['PA', '42'],
  ['RI', '44'],
  ['SC', '45'],
  ['SD', '46'],
  ['TN', '47'],
  ['TX', '48'],
  ['UT', '49'],
  ['VT', '50'],
  ['VA', '51'],
  ['WA', '53'],
  ['WV', '54'],
  ['WI', '55'],
  ['WY', '56'],
];

export default class TrialForm extends React.Component {
  state = {
    city: '',
    query: ''
  };

  handlePlaceSelect = () => {
    // Extract City From Address Object
    let addressObject = this.autocomplete.getPlace();
    let address = addressObject.address_components;
    const state = address.find(a => a.types.includes("administrative_area_level_1"))
    const city = address.find(a => a.types.includes("locality"))

    // Check if address is valid
    if (state && city) {
      this.props.onChange('city', city.long_name);
      this.props.onChange('location_state', state.short_name);
      // Set State
      this.setState(
        {
          city: address[0].long_name,
          query: addressObject.formatted_address,
        }
      );
    }
  }

  handleScriptLoad = () => {
    // Declare Options For Autocomplete 
    var options = { types: ["(cities)"] };

    // Initialize Google Autocomplete 
    /*global google*/
    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById("autocomplete"), options);
    // Fire Event when a suggested name is selected
    this.autocomplete.addListener("place_changed", this.handlePlaceSelect);
  }
  render() {
    let states = [];
    state_list.map(i => {
      states.push(<MenuItem key={i[1]} value={i[0]} primaryText={`${i[0]}`} />);
    });
    let cities = [];
    this.props.state.cities.map(city => {
      cities.push({
        label: city,
        value: city,
      });
    });
    let now = new Date().getFullYear();
    const years = [];
    for (let i = now; i > now - 90; i--) {
      years.push(<MenuItem value={i} key={i} primaryText={`${i}`} />);
    }
    return (
      <div className="panel">
        <Script url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_API_KEY}&libraries=places`}
          onLoad={this.handleScriptLoad}
        />
        <div className="panel-header">
          <p>
            Next, if you are interested in clinical trials, please provide the
            following info. If not, simply click skip.
          </p>
        </div>
        <div className="panel-body">
          <SelectField
            hintText="Birth Year"
            style={{ width: "100%" }}
            value={this.props.state.year}
            onChange={e =>
              this.props.onChange('year', parseInt(e.target.innerHTML, 10))}
            maxHeight={200}
          >
            {years}
          </SelectField>
          <br />
          <SelectField
            style={{ width: "100%" }}
            hintText="Gender"
            value={this.props.state.gender}
            onChange={e => this.props.onChange('gender', e.target.innerHTML)}
            maxHeight={200}
          >
            <MenuItem value={'Male'} primaryText={'Male'} />
            <MenuItem value={'Female'} primaryText={'Female'} />
          </SelectField>
          <br />
          <input className="input" id="autocomplete" placeholder="Search City"
            style={{
              margin: 0,
              width: "100%",
              maxWidth: "100%",
              fontWeight: 200,
              fontSize: 15
            }}
          />

        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TrialForm.js